// extracted by mini-css-extract-plugin
export default {"taglinePromotionPrimary":"styles_taglinePromotionPrimary__AgEn1","memberPrice":"styles_memberPrice__mixYY"};